import { RolodexEntryType } from 'types'

export const DEFAULT_SEARCHABLE_SLASH_TYPES = [
  RolodexEntryType.SYSTEM,
  RolodexEntryType.UNIT,
  RolodexEntryType.INSPECTION,
  RolodexEntryType.CHART,
]
